import React from 'react';

export const ElCercado = () => {
  return (
    <section id="el-cercado" className="section-padding bg-background">
      <div className="editorial-container">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Text Content */}
          <div className="space-y-8">
            <div>
              <span className="nav-label text-siena">El Pueblo</span>
              <h2 className="display-heading text-4xl md:text-5xl lg:text-6xl text-earth mt-4 mb-6">
                Cinco siglos de
                <br />
                <span className="text-siena">arcilla y fuego</span>
              </h2>
            </div>

            <div className="space-y-6 body-text text-base md:text-lg">
              <p>
                El Cercado es un pequeño pueblo al norte de la Isla de Margarita, a cuarenta 
                minutos de Porlamar. Sus familias llevan siglos convirtiendo arcilla en objetos 
                que sirven, que adornan y que duran.
              </p>
              <p>
                La tradición la sostienen artesanos de familias como los Domínguez y los 
                Bermúdez — nombres que se repiten porque el oficio se hereda.
              </p>
              <p>
                Todo empieza en el Cerro de la Cruz, donde se extraen tres tipos de arcilla 
                — blanca, negra y gris. El resto lo hacen el fuego y las manos que llevan 
                siglos manteniendo viva esta tradición.
              </p>
            </div>

            {/* UNESCO Badge */}
            <div className="flex items-center gap-4 pt-4">
              <div className="w-16 h-16 rounded-full bg-caribbean/10 flex items-center justify-center">
                <svg className="w-8 h-8 text-caribbean" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5z" />
                </svg>
              </div>
              <div>
                <p className="text-sm font-medium text-earth uppercase tracking-wide">Candidatura UNESCO</p>
                <p className="text-sm text-stone">Patrimonio Cultural Inmaterial · 2015</p>
              </div>
            </div>
          </div>

          {/* Single Featured Image - Fachada Original */}
          <div className="mt-12">
            <img
              src="/images/el_pueblo_1.jpg"
              alt="Escuela de El Cercado"
              className="w-full max-w-5xl mx-auto h-[400px] md:h-[600px] object-cover rounded-lg shadow-2xl"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
